import React, { useEffect, useRef, useState } from "react";
import "animate.css";

import img from "../../assets/img/special-offer-invis.webp";

const HeroSection = ({ scrollToConsult }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      className="container-fluid text-white d-flex align-items-center"
      style={{
        backgroundImage: `url(${img})`,
        backgroundSize: "cover",
        minHeight: "90vh",
      }}>
      <div className="w-100 px-md-5 py-md-5 py-5" ref={sectionRef}>
        <div className="px-lg-5 mb-3">
          <h2
            className={`fs-40 fw-800 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}>
            Our Special Offer on <br />
            Invisalign®
          </h2>
          <button className="btn btn-golden mt-3" onClick={scrollToConsult}>
            <a href="#consult" className="text-white">
              BOOK A FREE CONSULTATION
            </a>
          </button>
          <p
            className={`fs-17 fw-200 mt-3 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}>
            Over £1000 of Extras included:
          </p>

          <div className="row">
            <div className="col-lg-3 mb-3">
              <div className="card border border-1 bg-transparent">
                <div className="card-body mt-2">
                  <div className="d-flex justify-content-start">
                    <div>
                      <i
                        className="fa fa-check-circle text-golden fa-2x"
                        aria-hidden="true"></i>
                    </div>
                    <div className="ms-3">
                      <h3 className="text-white fs-30">
                        {" "}
                        <span className="text-golden">20%</span> OFF
                      </h3>
                      <p className="text-white fs-14">Your Invisalign® today</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 mb-3">
              <div className="card border border-1 bg-transparent">
                <div className="card-body mt-2">
                  <div className="d-flex justify-content-start">
                    <div>
                      <i
                        className="fa fa-check-circle text-golden fa-2x"
                        aria-hidden="true"></i>
                    </div>
                    <div className="ms-3">
                      <h3 className="text-white fs-30">
                        {" "}
                        Save <span className="text-golden">£75</span>{" "}
                      </h3>
                      <p className="text-white fs-14">FREE 3D SCAN</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 mb-3">
              <div className="card border border-1 bg-transparent">
                <div className="card-body mt-2">
                  <div className="d-flex justify-content-start">
                    <div>
                      <i
                        className="fa fa-check-circle text-golden fa-2x"
                        aria-hidden="true"></i>
                    </div>
                    <div className="ms-3">
                      <h3 className="text-white fs-30">
                        Save <span className="text-golden">£300</span>
                      </h3>
                      <p className="text-white fs-14">
                        with a Clincheck Treatment Simulation
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3"></div>
            <div className="col-lg-3 mb-3">
              <div className="card border border-1 bg-transparent">
                <div className="card-body mt-2">
                  <div className="d-flex justify-content-start">
                    <div>
                      <i
                        className="fa fa-check-circle text-golden fa-2x"
                        aria-hidden="true"></i>
                    </div>
                    <div className="ms-3">
                      <h3 className="text-white fs-30">
                        Save <span className="text-golden">£295</span>
                      </h3>
                      <p className="text-white fs-14">
                        with Boutique Teeth Whitening
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 mb-3">
              <div className="card border border-1 bg-transparent">
                <div className="card-body mt-2">
                  <div className="d-flex justify-content-start">
                    <div>
                      <i
                        className="fa fa-check-circle text-golden fa-2x"
                        aria-hidden="true"></i>
                    </div>
                    <div className="ms-3">
                      <h3 className="text-white fs-30">
                        Save <span className="text-golden">£400</span>
                      </h3>
                      <p className="text-white fs-14">with Retainers</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
